import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createEndorsementPendingPaymentSlice = (set, get) => ({
    endorsementPendingPayment: {
        loading: false,
        data: [],
        comments: []
    },
    getEndorsementPendingPayment: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ endorsementPendingPayment: { ...state.endorsementPendingPayment, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: "v1/business/endorsement/pending-payment-report",
                headers: { token },
            });
            set(state => ({ endorsementPendingPayment: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ endorsementPendingPayment: { ...state.endorsementPendingPayment, loading: false } }));
        }
    }
});
